import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {MeService} from './api/me.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private meService: MeService,
    private router: Router,
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.meService.me) {
      return true;
    }

    this.router.navigate(['/login']);

    return false;
  }
}
